export const STUDIO_LOCATOR = "/studio-locator";
